var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#ffdbe1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6483 31.744H26.2963C25.9843 29.824 25.7683 26.608 25.7683 23.488V19.456H29.2243V23.488C29.2243 26.68 28.9843 29.896 28.6483 31.744ZM27.4963 37.312C26.4163 37.312 25.5283 36.448 25.5283 35.416C25.5283 34.36 26.4163 33.496 27.4963 33.496C28.5283 33.496 29.4163 34.36 29.4163 35.416C29.4163 36.448 28.5283 37.312 27.4963 37.312Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItem);
export default __webpack_public_path__ + "static/media/noItem.8772519f570ecd23cfe598c921ff425c.svg";
export { ForwardRef as ReactComponent };